import NavBar  from '@/components/NavBar';
import Footer from '@/components/Footer';
import Utils from '@/utils/util.js';
import Firebase from 'firebase/app'
import dataStore from '@/firebase/dataStore';

export default {   
    data() {
        return {

            entityName:"",

            object:{
                id:'',
                createdBy:'',
                createdAt:'',
                modifiedBy:'',
                modifiedAt:'',
            },     
            
            originalObject: {},


            isInitiating    :false,
            isLoading       :false,

            showSnackbar    :false,
            snackbarColor   :'green',
            snackBarText    :'', 
            
            activeMode      : 'new',            
        }
    },
    components: {          
        NavBar,         
        Footer,        
    },
    computed: {
        getSubmitBtnTxt(){
            if(this.activeMode == 'new'){
                return 'Create ' + this.getEntitiyDisplayName();
            }else if(this.activeMode == 'edit'){
                return 'Save Changes';
            }
            return '';
        }
    },
    created() {

        this.isInitiating = true;

        if(this.mode == undefined){
            this.activeMode = 'new';                
        }else{
            this.activeMode = this.mode;                
        } 

        this.onCreated();  

        this.isInitiating = false;
    },
    props:{
        mode:String,
        id:String,
    }, 
    methods: {
        getTableName(){
            return this.entityName.toLowerCase();
        },
        getEntitiyDisplayName(){
            return this.entityName;
        },
        getEntitiyDisplayNamePlural(){
            return this.entityName + "s";
        },
        getUser(){
            return this.$store.state.user.name;
        },
        async onCreated(){             

            await this.fetchRefData();  


            if(this.activeMode == 'new'){                
                this.object.id = Utils.getUniqueID(); // This is required because child records are linked with this ID
            }else{
                this.object.id = this.id;
                await this.fetchObject(this.object.id);
            }    
            
            this.deriveOriginalObject(); // For page leave warning

        },    
        async fetchRefData(){     

            this.clients = [];
            
            const data = await dataStore.getAll("clients", [], [["modifiedAt", "desc"]]);

            for(const doc of data){
                this.clients.push({ value: doc.id, text: doc.name });
            }

            this.clients.sort((a,b) => a.text.toLowerCase() < b.text.toLowerCase()? -1 : a.text.toLowerCase() > b.text.toLowerCase() ? 1 : 0)

        }, 
        async fetchObject(id){  

            const data = await dataStore.get(this.getTableName(), id);
            if(data != null){
                this.object = data; // TODO - DO DEEP COPYING
                await this.afterFetchObject(id);
            }else{
                this.showError("Failed to fetch record");
            }
        }, 
        async afterFetchObject(id){return id;},
        submit(){
            if(this.activeMode == 'new'){
                this.create();
            }else if(this.activeMode == 'edit'){
                this.update();
            }
        },
        async create(){

            this.isLoading = true;
            
            this.enrichObject();

            const res = await this.beforeCreate();
            if(res != true){
                this.showError('Failed to create ' + this.getEntitiyDisplayName() + ":");
                this.isLoading = false;
                return;
            }
            
            var DBBatch = dataStore.initNewBatch(this.getTableName(), true, this.object);
            this.addAdditionalItemsToBatch(DBBatch);
            

            dataStore.commitBatch(DBBatch).then(() =>{
                this.showMsg(this.getEntitiyDisplayName() + " created successfully");
                this.resetForm();
                this.isLoading = false;
            }).catch((e) => {
                this.showError('Failed to create ' + this.getEntitiyDisplayName() + ":" + e);
                this.isLoading = false;
            }); 
        },      
        async update(){  

            this.isLoading = true;
            
            this.enrichObject();

            const res = await this.beforeUpdate();
            if(res != true){
                this.showError('Failed to update ' + this.getEntitiyDisplayName() + ":");
                this.isLoading = false;
                return;
            }

            var DBBatch = dataStore.initNewBatch(this.getTableName(), false, this.object);
            this.addAdditionalItemsToBatch(DBBatch);
            
            dataStore.commitBatch(DBBatch).then(() =>{
                this.showMsg(this.getEntitiyDisplayName() + " updated successfully");
                this.deriveOriginalObject();
                this.isLoading = false;
            }).catch((e) => {
                this.showError('Failed to update ' + this.getEntitiyDisplayName() + ":" + e);
                this.isLoading = false;
            }); 

        },
        enrichObject(){
            if(this.activeMode == 'new'){
                this.object.createdBy   = Utils.getUser();
                this.object.createdAt   = Firebase.firestore.FieldValue.serverTimestamp();
            }            
            this.object.modifiedBy = Utils.getUser();
            this.object.modifiedAt = Firebase.firestore.FieldValue.serverTimestamp();
        },
        async beforeCreate(){},
        async beforeUpdate(){},
        addAdditionalItemsToBatch(DBBatch){return DBBatch},
        showError(err){
            this.snackBarText = err;
            this.snackbarColor = 'red';
            this.showSnackbar = true;
        },          
        showMsg(msg){
            this.snackBarText = msg;
            this.snackbarColor = 'green';
            this.showSnackbar = true;
        },
        deriveOriginalObject(){
            this.originalObject = {};
            for(let field in this.object){
                if(field != 'id' && field != 'createdBy' && field != 'createdAt' && field != 'modifiedBy' && field != 'modifiedAt'){
                    this.originalObject[field] = this.object[field];
                }
            }
        },
        deriveCurrentObject(){
            let currentObject = {};
            for(let field in this.object){
                if(field != 'id' && field != 'createdBy' && field != 'createdAt' && field != 'modifiedBy' && field != 'modifiedAt'){
                    currentObject[field] = this.object[field];
                }
            }

            return currentObject;
        },
        isThereUnsavedChanges(){
            const currentObject = this.deriveCurrentObject();
            if(JSON.stringify(this.originalObject) === JSON.stringify(currentObject)){
                return false;
            }else{
                return true;
            }
        }, 
        resetForm(){
            for(let field in this.object){
                this.object[field] = '';
            }
            this.object.id = Utils.getUniqueID();
            this.resetFormEx();
        },  
        resetFormEx(){}          
    },
    beforeRouteLeave: function(to, from, next) {
        if(this.isThereUnsavedChanges() == true){
            const answer = window.confirm('You have unsaved changes; are you sure you want to leave this page?')
            if (answer) {
                next()
            } else {
                next(false)
            }
        }else{
            next();
        }     
    }
    
}
